// extracted by mini-css-extract-plugin
export default {"productGrid":"u5-z","centerLink":"v5-z","productSection":"w5-z","item":"x5-z","ctaButton":"y5-z"};